import { IDtoFieldDescriptor, Utils } from "..";
import { graphQlToFieldTypeMapping } from "../entity_crud/FieldType";
import { IReportDescriptor } from "./IReportDescriptor";
import { ReportDescriptorMaterializer } from "./ReportDescriptorMaterializer";

export class ReportDescriptorMaterializers {

    public static INSTANCE: ReportDescriptorMaterializers = new ReportDescriptorMaterializers();

    protected registry: { [reportId: string]: ReportDescriptorMaterializer } = {};

    public getRegistry() {
        return this.registry;
    }
    
    addReportDescriptorMaterializer(materializer: ReportDescriptorMaterializer) {
        const reportId = materializer.reportDescriptor.id;
        if (this.registry[reportId]) {
            throw new Error("There is already an entry for: " + reportId);
        }
        this.registry[reportId] = materializer;
    }

    addReportDescriptor(descriptor: IReportDescriptor) {
        // Map field types using the GraphQL to field type mapping
        Object.values(descriptor.paramDtoDescriptor.fields).forEach((field: IDtoFieldDescriptor) => {
            const mappedType = graphQlToFieldTypeMapping[field.type];
            if (mappedType) {
                field.type = mappedType;
            }
        });
        this.addReportDescriptorMaterializer(new ReportDescriptorMaterializer(descriptor));
    }

    async getReportDescriptorsForServer() {
        const url = Utils.adjustUrlToServerContext('api/background-tasks/report-descriptors');
        const response = await fetch(url!, { method: "GET" });
        if (!response.ok) {
            throw new Error(`Couldn't get the report descriptors! HTTP error status: ${response.status}`);
        }
        const reportDescriptors: IReportDescriptor[] = await response.json();
        reportDescriptors.forEach(descriptor => this.addReportDescriptor(descriptor));
        return reportDescriptors;
    }
}